import { useState } from "react";
import { useNavigate } from "react-router";
import { TitleImage, UserButton } from "./BaseComponents";

export default function Projects() {
  const [currentView, setCurrentView] = useState("main");
  const navigate = useNavigate();
  const username = localStorage.getItem("username");

  const signOut = () => {
    localStorage.removeItem(username);
    localStorage.removeItem("username");
    navigate("/");
  };

  const profile = () => {
    navigate("/profile");
  };

  if (currentView === "gateway") {
    return (
      <div className="App-body">
        {TitleImage()}
        <div className="ContentBorder">
          <h3 className="Left-align">[ gateway optimization ]</h3>
          <p className="Left-align">
            a team of crack engineers at swampyankeetech have optimized router placement by placing our router on its side
            increasing airflow, reducing fan noise, and improving power efficiency.
          </p>
          <img src='images/optimized_internet_gateway.jpeg' alt="optimized internet gateway" />
        </div>
        <div className="User-2H-button-div">
          <div className="User-button-div-left">
            <UserButton button_name="projects" do_something={() => setCurrentView("main")} />
          </div>
          <div className="User-button-div-right">
            <UserButton button_name="sign out" do_something={signOut} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App-body">
      {TitleImage()}
      <div className="ContentBorder">
        <p className="Left-align">
          below are several projects developed by the crack team at swampyankeetech.
          to invest early and often in these or similar projects,
          please contact the team via electronic mail: brokenlink@swampyankeetech.com.
        </p>
        <p className="Left-align">
          (note, swampyankeetech investments are only accepted as geocaches of old crow and chew, under terms of an infinite valuation.)
        </p>
        <br />
        <h3 className="Left-align">[ semi-functional ]</h3>
        <ul className="Left-align">
          <li>darkroom finder: <a href="https://darkroomfinder.org">https://darkroomfinder.org</a></li>
          <li>simple container monitor: <a href="https://github.com/sophist0/container_monitor">https://github.com/sophist0/container_monitor</a></li>
          <li>simple down detector: <a href="https://github.com/sophist0/simple_downdetector_public">https://github.com/sophist0/simple_downdetector_public</a></li>
          <li>gops agents: <a href="https://github.com/sophist0/gops">https://github.com/sophist0/gops</a></li>
        </ul>
        <br />
        <h3 className="Left-align">[ ideation ]</h3>
        <ul className="Left-align">
          <li>llm cache*</li>
          <li>digital asset ownership verification</li>
        </ul>
        <br />
        <h3 className="Left-align">[ deprecated ]</h3>
        <ul className="Left-align">
          <li>delete bot: <a href="https://github.com/sophist0/delete_bot">https://github.com/sophist0/delete_bot</a></li>
          <li>
            <a href="#gateway-optimization" onClick={(e) => { e.preventDefault(); setCurrentView("gateway"); }}>
              internet gateway optimization</a>*
          </li>
        </ul>
        <br />
        (*) indicates a game changer's game changer and in no way is a swamp yankee tall tale;
        just as every swamp yankee walks up hill to and from the package store.....
      </div>
      <div className="User-2H-button-div">
        <div className="User-button-div-left">
          <UserButton button_name="profile" do_something={profile} />
        </div>
        <div className="User-button-div-right">
          <UserButton button_name="sign out" do_something={signOut} />
        </div>
      </div>
    </div>
  );
}

